import type { TooltipDirection, TooltipPosition } from './types.ts';

const POPUP_WIDTH = 132;
const CORNER_OFFSET = 8;
const TOP_OFFSET = 120;

const getDirection = (y: number): TooltipDirection => {
  return y < TOP_OFFSET ? 'down' : 'up';
};

const getHorizontalOffset = (left: number) => {
  if (left < CORNER_OFFSET) {
    return CORNER_OFFSET - left;
  }
  const right = left + POPUP_WIDTH;
  if (right > document.documentElement.clientWidth - CORNER_OFFSET) {
    return document.documentElement.clientWidth - right - CORNER_OFFSET;
  }
  return 0;
};

const getVerticalOffset = (element: Element | null): number => {
  if (element instanceof HTMLElement) {
    const rect = element.getBoundingClientRect();

    return rect.top + window.scrollY;
  }
  return 0;
};

export const getPosition = (element: Element): TooltipPosition => {
  const { x, y, width, height } = element.getBoundingClientRect();
  const offsetTop = getVerticalOffset(element);
  const direction = getDirection(y);
  const left = x + (width - POPUP_WIDTH) / 2;
  const top =
    offsetTop + height / 2 + (height / 2) * (direction === 'down' ? 1 : -1);
  const offset = getHorizontalOffset(left);

  return { left, top, direction, offset };
};
